import { SagaMiddleware } from 'redux-saga';
import * as sagas from '../sagas';

export const initSagas = (sagaMiddleware: SagaMiddleware<any>) => {
  Object.values(sagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
};
